module.exports = __webpack_public_path__ + "static/media/calendar.d229b22b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Icons/calendar.svg
// module id = 874
// module chunks = 21